<script>
  // The picked bundle's cards in card view: the shared card tile with the
  // binder's pills over it (VISUALS.md "A card looks the same everywhere"):
  // the image, the price pill (rainbow dot when foil) and no caption. On the
  // owner's Default Want List the first tile is Add a card (`addTile`) and
  // each card opens its options (`onOpen`).
  import { getCardImageUrl } from '../../lib/services/card-utils.js';
  import CardTile from '../shared/CardTile.svelte';
  import CardPills from '../shared/CardPills.svelte';

  /** @typedef {import('../../lib/logic/want-page-logic.js').WantRow} WantRow */

  /**
   * @type {{
   *   rows: WantRow[],
   *   addTile?: import('svelte').Snippet,
   *   onOpen?: (row: WantRow) => void,
   * }}
   */
  let { rows, addTile, onOpen } = $props();
</script>

<ul class="tiles" aria-label="Wanted cards">
  {#if addTile}
    <li class="tile add-tile">
      <div class="add-card">
        <span class="add-plus" aria-hidden="true">+</span>
        {@render addTile()}
      </div>
    </li>
  {/if}
  {#each rows as row (row.id)}
    <li class="tile" data-entry={row.id}>
      <CardTile
        name={row.name}
        imageUrl={row.scryfallId ? getCardImageUrl({ scryfallId: row.scryfallId }, 'normal') : null}
        onclick={onOpen ? () => onOpen(row) : null}
      >
        {#snippet overlay()}
          <CardPills price={row.price} foil={row.mark === 'foil'} />
        {/snippet}
      </CardTile>
    </li>
  {/each}
</ul>

<style>
  .tiles {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 14px;
  }
  /* Card-shaped, dashed: a place a card goes. */
  .add-card {
    aspect-ratio: 488 / 680;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 8px;
    border: 1.5px dashed var(--color-text-muted);
    border-radius: 4.75% / 3.5%;
  }
  .add-plus {
    font-size: 34px;
    font-weight: 300;
    line-height: 1;
    color: var(--color-text-secondary);
  }
  @media (max-width: 768px) {
    .tiles {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px;
    }
  }
</style>
